export default "__VITE_ASSET__1803d4e1__"